import { render, staticRenderFns } from "./IconPlusSmSolid.vue?vue&type=template&id=2a89e359"
import script from "./IconPlusSmSolid.vue?vue&type=script&lang=js"
export * from "./IconPlusSmSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports